import { render } from "./DeleteOrAddFormItemsDynamically.vue?vue&type=template&id=70e0329a"
import script from "./DeleteOrAddFormItemsDynamically.vue?vue&type=script&lang=js"
export * from "./DeleteOrAddFormItemsDynamically.vue?vue&type=script&lang=js"
script.render = render

export default script